import { FC, ReactNode } from 'react';
import { trackFooterNavigationClick } from '../../helpers/trackingHelpers';
import { SeoLink } from 'dibs-elements/exports/SeoLink';

type Props = {
    trackingLabel: string;
    serverRenderedChildren: ReactNode;
    href: string;
    isLinkable: boolean;
    target?: '_blank';
    dataTn: string;
    linkContent: ReactNode;
};

const FooterSeoLinkWrapper: FC<Props> = ({
    trackingLabel,
    href,
    isLinkable,
    target,
    dataTn,
    linkContent,
}) => (
    <SeoLink
        onClick={event => {
            trackFooterNavigationClick({ label: trackingLabel }, event);
        }}
        linkData={{
            path: href,
            isLinkable,
        }}
        target={target}
        dataTn={dataTn}
        buyerLinkType="standardLinkNoUnderline"
    >
        {linkContent}
    </SeoLink>
);

export default FooterSeoLinkWrapper;
